/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const brandingFontDataRequestSchema = z.object({
	title: z.string().nullable().optional(),
	body: z.string().nullable().optional(),
})

export type BrandingFontDataRequestSchema = z.infer<typeof brandingFontDataRequestSchema>
